import { useGetAuthMe } from "@birdwatch/client";
import { getUserRole } from "@/libs/user-role";

export default function useUserRole() {
  const { data: me, isLoading } = useGetAuthMe().get();
  // me is always defined thanks to Null Object Pattern
  const { isAdmin, isManager, isTechnician, isEvaluator, isOwner } =
    getUserRole(me?.roles || []);

  return {
    isLoading,
    isAdmin,
    isManager,
    isTechnician,
    isEvaluator,
    isOwner,
  };
}
